/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} East_Loose_Leopard_DreamInputs */

const es_east_loose_leopard_dream = /** @type {(inputs: East_Loose_Leopard_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`y la`)
};

const gl_east_loose_leopard_dream = /** @type {(inputs: East_Loose_Leopard_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e o`)
};

const en_east_loose_leopard_dream = /** @type {(inputs: East_Loose_Leopard_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and the`)
};

/**
* | output |
* | --- |
* | "and the" |
*
* @param {East_Loose_Leopard_DreamInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const east_loose_leopard_dream = /** @type {((inputs?: East_Loose_Leopard_DreamInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<East_Loose_Leopard_DreamInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_east_loose_leopard_dream(inputs)
	if (locale === "en") return en_east_loose_leopard_dream(inputs)
	return es_east_loose_leopard_dream(inputs)
});